import React, { useState } from "react";
import TokenModal from "./TokenDialog";

const Deposit = () => {
  const [openBuy, setOpenBuy] = useState(false);
  const [selectedBuy, setSelectedBuy] = useState("BASE");

  return (
    <div className="w-full max-w-[524px] flex flex-col gap-3 items-center card-3d p-4 sm:p-6">
      <div className="rounded-2xl overflow-hidden border border-usdx-line w-full">
        <div className="bg-usdx-surface/70 text-usdx-ink-muted flex flex-wrap gap-x-4 gap-y-1 justify-between text-[13px] sm:text-[15px] px-4 sm:px-6 py-2.5 border-b border-usdx-line">
          <h6>
            From: <b className="text-usdx-ink">USDX</b>
          </h6>
          <p>
            Balance: <b className="num text-usdx-ink">0 ETH</b>
          </p>
        </div>

        <div className="bg-usdx-surface-sunken/60 flex items-center flex-col justify-between px-4 sm:px-6 py-5 sm:py-6 gap-3">
          <div className="flex items-stretch justify-between w-full rounded-xl overflow-hidden bg-usdx-surface border border-usdx-line focus-within:border-usdx-accent/50 transition-colors">
            <button
              type="button"
              onClick={() => setOpenBuy(!openBuy)}
              className="flex items-center justify-center shrink-0 px-3 py-2.5 border-r border-usdx-line gap-1.5 sm:gap-2.5 bg-transparent cursor-pointer hover:bg-usdx-brand-50 transition-colors"
            >
              <span className="font-semibold text-[14px] sm:text-[17px] text-usdx-ink">
                {selectedBuy}
              </span>
              <svg
                className="w-3.5 h-3.5 text-usdx-ink-subtle"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <input
              placeholder="0.0"
              aria-label="Amount to move"
              inputMode="decimal"
              className="num min-w-0 flex-1 px-3 py-2.5 bg-transparent text-usdx-ink placeholder:text-usdx-ink-subtle/60 outline-none text-[15px] sm:text-[16px]"
            />
          </div>

          <div className="flex flex-wrap gap-x-3 gap-y-1 justify-between w-full">
            <h6 className="text-usdx-ink-muted text-[13px]">USDX Chain gas fee</h6>
            <p className="num text-usdx-ink text-[13px] font-medium">0.0001 ETH</p>
          </div>
        </div>
      </div>

      {/* Direction indicator. Sits in the column gap between the two panels;
          the parent's gap-3 already spaces it. */}
      <div className="swap-arrow-3d w-9 h-9 flex items-center justify-center">
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </svg>
      </div>

      <div className="rounded-2xl overflow-hidden border border-usdx-line w-full bg-usdx-brand-50/50 p-3">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 justify-between p-3 w-full rounded-xl bg-usdx-surface border border-usdx-line">
          <h6 className="text-usdx-ink text-[15px] font-medium">
            To: <b>Holesky</b>
          </h6>
          <p className="text-usdx-ink-muted text-[13px] font-medium">
            Balance: <b className="num text-usdx-ink">0 ETH</b>
          </p>
        </div>
      </div>

      <button
        type="button"
        className="btn-3d w-full mt-1 rounded-full py-4 px-4 text-[16px] sm:text-[18px] font-semibold"
      >
        Move funds to Holesky
      </button>

      <div className="w-full flex flex-col gap-2 pt-1">
        <h6 className="text-usdx-ink-muted text-[13px] font-semibold">Summary:</h6>

        <div className="flex flex-wrap gap-x-3 gap-y-1 justify-between w-full">
          <h6 className="text-usdx-ink-subtle text-[13px]">
            You will pay in gas fees:
          </h6>
          <p className="num text-usdx-ink text-[13px] font-medium">0.0001 ETH</p>
        </div>

        <div className="flex flex-wrap gap-x-3 gap-y-1 justify-between w-full">
          <h6 className="text-usdx-ink-subtle text-[13px]">
            You will receive on Holesky:
          </h6>
          <p className="num text-usdx-ink text-[13px] font-medium">0 ETH</p>
        </div>
      </div>

      <TokenModal open={openBuy} setOpen={setOpenBuy} onClick={setSelectedBuy} />
    </div>
  );
};

export default Deposit;
